import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "antd";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import "@/styles/pages/notes.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import PreviewComponent from "@/components/preview/PreviewComponent";
import Slider from "react-slick";
import Session from "@/pages/session/Session";
import { getSharedNotes } from "@/services/guides/notes";

const Notes = () => {
  const [noteList, setNoteList] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Adjust threshold as needed

  const fetchData = async () => {
    try {
      const res = await getSharedNotes();
      setNoteList(res.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const getPreviewData = (fileName, fileUrl) => {
    const fileExtension = fileName.split(".").pop()?.toLowerCase();
    let previewType = "document";
    let placeholderImg = "/assets/images/default_file_img.png";

    if (["mp4", "mov", "avi"].includes(fileExtension || "")) {
      previewType = "video";
      placeholderImg = "/assets/images/video_img.png";
    } else if (["pdf"].includes(fileExtension || "")) {
      placeholderImg = "/assets/images/pdf_img.svg";
    } else {
      placeholderImg = fileUrl || placeholderImg;
    }

    return { previewType, placeholderImg };
  };

  return (
    <Fragment>
      <div className="notes-page">
        <Container>
          <CardComponent>
            <div className="options-container">
              <Row>
                <Col span={24}>
                  <div className="heading">
                    <BackWithLabel label="My Notes" path="/dashboard" />
                  </div>
                </Col>
              </Row>

              {noteList.length ? (
                isMobile ? (
                  <div className="note-carousel">
                    <Slider {...settings}>
                      {noteList.map((note) => {
                        const { previewType, placeholderImg } = getPreviewData(
                          note.fileName,
                          note.fileUrl
                        );

                        return (
                          <div key={note.id} className="note-section">
                            <PreviewComponent
                              img_url={placeholderImg}
                              url={note.fileUrl}
                              type={previewType}
                            />
                            <div className="note-label">
                              <label>File Name: {note.fileName}</label>
                              <label>
                                Uploaded At: {new Date(note.createdAt).toLocaleString()}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                ) : (
                  <Row gutter={[16, 16]}>
                    {noteList.map((note) => {
                      const { previewType, placeholderImg } = getPreviewData(
                        note.fileName,
                        note.fileUrl
                      );

                      return (
                        <Col key={note.id} xxl={4} xl={6} lg={6} md={12} sm={24} xs={24}>
                          <div className="note-section">
                            <PreviewComponent
                              img_url={placeholderImg}
                              url={note.fileUrl}
                              type={previewType}
                            />
                            <div className="note-label">
                              <label>{note.fileName}</label>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                )
              ) : (
                <Session isGuidePanel heading="No Notes Found" />
              )}
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default Notes;
